<h1 mat-dialog-title>In Behandlungsraum verschieben</h1>
<div mat-dialog-content>
    <kiene-autocomplete
        [apiUrl]="'behandlungsraum/'"
        [kieneObject]="behandlungsraum"
        [displayFields]="['name', 'kunde']"
        [separator]="' --- belegt: '"
        [panelWidth]="'150px'"
        [placeholder]="'Behandlungsraum'"
        (elementSelected)="selectRaum($event)"
    ></kiene-autocomplete>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Verschieben</button>
</div>
